import React from 'react'
import { components } from 'react-select'
import ExpiryDisplay from '../components/ExpiryDisplay'

const ExpiryOption = ({ children, ...props }: React.ComponentProps<typeof components.Option>) => {
  const { Option } = components

  return (
    <Option {...props}>
      <ExpiryDisplay>{children}</ExpiryDisplay>
    </Option>
  )
}

export default ExpiryOption
